import React, { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { PropsOf } from '@headlessui/react/dist/types';
import PrimaryButton from '../buttons/PrimaryButton';
import PrimaryLinkButton from '../buttons/PrimaryLinkButton';

interface PageHeaderProps {
  title: string;
  badge?: ReactNode;
  subtitle?: string | ReactNode;
  className?: string;
  primaryButton?:
    | ReactElement<PropsOf<typeof PrimaryButton>>
    | ReactElement<PropsOf<typeof PrimaryLinkButton>>;
  secondaryButton?: ReactNode;
}

export default function PageHeader({
  title,
  subtitle,
  badge,
  className,
  primaryButton,
  secondaryButton,
}: PageHeaderProps): JSX.Element {
  return (
    <header className={twMerge('flex flex-col gap-1 pb-4', className)}>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-semibold text-primary-900">{title}</h1>
          {badge}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {secondaryButton}
          {primaryButton}
        </div>
      </div>
      {subtitle && <p className="max-w-2xl pb-2 text-sm text-gray-500">{subtitle}</p>}
    </header>
  );
}
